import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { H2, H4, NamedLink } from '../../../components';
import { FormattedMessage } from 'react-intl';

import { stringify } from 'query-string';
import css from './SectionDiscover.module.css';

const SectionDiscover = props => {
  const { rootClassName, className, columnContent, config } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <H2 className={css.title}>
        <FormattedMessage id="LawyerLandingPage.SectionDiscover.title" />
      </H2>

      <div className={css.sectionDiscover}>
        {columnContent.map(column => {
          const { key, title, content, address, bounds } = column;
          return (
            <div key={key} className={css.item}>
              <H4>{title}</H4>
              {content.map(({ key, label, searchable }) => (
                <NamedLink
                  key={key}
                  name="SearchPage"
                  to={{
                    search: stringify({
                      address,
                      bounds,
                      ...(searchable
                        ? {
                            pub_category: key,
                          }
                        : {}),
                    }),
                  }}
                >
                  {label}
                </NamedLink>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

SectionDiscover.defaultProps = { rootClassName: null, className: null };

SectionDiscover.propTypes = {
  rootClassName: string,
  className: string,
  columnContent: arrayOf(
    shape({
      title: string,
      key: string,
      content: arrayOf(
        shape({
          key: string,
          label: string,
        })
      ),
    })
  ).isRequired,
};

export default SectionDiscover;
